import { render, staticRenderFns } from "./CreateAllowanceForAllowanceBreakdownTypeCompleted.vue?vue&type=template&id=000f856a"
import script from "./CreateAllowanceForAllowanceBreakdownTypeCompleted.vue?vue&type=script&lang=js"
export * from "./CreateAllowanceForAllowanceBreakdownTypeCompleted.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports